var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturatedFatResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F60;}\n\t.st1{fill:#F7DF7E;}\n\t.st2{fill:#F6EA96;}\n\t.st3{fill:#F8D060;}\n\t.st4{fill:#F7EDD2;}\n\t.st5{fill:#AA1917;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.7,134.4c0,1,29.2,4.6,32.1,5c10.5,1.6,21,2.7,31.3,5c0.4,0.1,1,0.2,1.3-0.1c0.4-0.3,0.4-0.8,0.4-1.3 c0.2-9.5,0.3-19,0.3-28.6c0-1.7-0.1-3.6-1.2-4.9c-1-1-2.4-1.4-3.8-1.6c-18.5-3.7-37.3-4.7-56.1-5.8c-1-0.1-2.1,0-2.7,0.8 c-0.3,0.4-0.4,0.9-0.4,1.4C59.7,114.4,59.3,124.4,59.7,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.2,103.4c1.7-1.9,4.1-3,6.3-4.1c5-2.5,10.1-5,15.1-7.4c2.3-1.1,4.6-2.2,7.1-2.5c2-0.2,4,0,6,0.3 c17.8,2.5,35.6,4.7,53.6,4.8c0.6,0,1.2,0,1.6,0.4c0.8,0.8,0,2.2-0.8,3c-4.8,4.8-9.8,10.1-15.3,14c-4.2,2.9-6.7,2-10.6-0.5 c-5-3.2-10.8-3.4-16.6-4.1c-7.3-0.9-14.6-1.6-21.9-2.2c-4.1-0.3-8.2-0.7-12.4-0.9C71.5,104,62.3,102.3,61.2,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M126.3,107.8c-0.8,0.6-1.6,1.1-2.1,2c-0.7,1.1-0.7,2.4-0.7,3.7c0,3.2,0.1,6.3,0.1,9.5 c0.1,6.6,0.1,13.2,0.2,19.8c0,0.8,0.1,1.9,0.9,2.2c0.9,0.4,1.8-0.4,2.4-1c5.1-5.2,11.1-9.4,17.7-12.4c3.5-1.6,7.4-3.2,8.8-6.8 c0.6-1.6,0.6-3.3,0.5-5c-0.1-5-0.3-10-0.4-15.1c-0.1-3.3,1.4-10.7-2.9-10.4c-4,0.3-9.1,3.7-12.5,5.6 C134.1,102.4,130.2,105.1,126.3,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M131.2,106.7c-1.7,1.4-3.5,2.9-4.4,5c-0.7,1.4-0.9,3-1.1,4.6c-0.6,4.6-1.1,9.1-1.7,13.7 c-0.5-3.9-1-7.9-1.6-11.8c-0.3-2.1-0.7-4.4-2.4-5.5c-1-0.7-2.3-0.9-3.6-1c-14.8-1.7-29.4-5-44-8.3c11,1,22,2,33,2.9 c5.5,0.5,11.1,1,16.6,0c5-0.9,9.6-3,14.1-5.2c4.5-2.2,9.2-4.1,13.6-6.4C143.1,97.2,136.6,102.3,131.2,106.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.6,101.1c-0.2-0.5-0.5-1-0.6-1.6c-2.3-8.1-4.5-16.2-6.8-24.2c-0.1-0.4-0.1-0.9,0-1.3 c0.3-0.9,1.2-1.3,2.1-1c0.2,0.1,0.4,0.2,0.6,0.3c2.4,1.3,4.8,2.6,7.3,3.9c0.2,0.1,0.4,0.2,0.6,0.3c0.5-0.8,1-1.5,1.5-2.2 c2.5-3.7,5.7-6.8,9.6-9.1c8.2-4.9,16.9-6,26.1-3.2c1.8,0.6,3.6,1.5,5.3,2.3c0.8,0.4,1.2,1.1,1,1.9c-0.2,0.8-0.8,1.3-1.8,1.3 c-3.7,0.1-7.2,0.8-10.6,2.2c-4.8,2-8.8,5.1-11.8,9.3c-1.3,1.9-2.4,3.9-3.7,5.9c0.3,0.2,0.5,0.3,0.6,0.4c2.5,1.4,5,2.7,7.5,4.1 c1,0.5,1.3,1.2,1.1,2.1c-0.2,0.7-0.7,1-1.3,1.2c-2.5,0.8-5,1.6-7.5,2.3c-5.6,1.8-11.2,3.5-16.8,5.3c-0.5,0.1-1,0.2-1.5,0.3 C98.2,101.4,97.9,101.2,97.6,101.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturatedFatResponse);
export default __webpack_public_path__ + "static/media/SaturatedFat_Response.d2d59976c40a6d5a57527ee5e0598899.svg";
export { ForwardRef as ReactComponent };